import ProjectOrderDetails from './ProjectOrderDetails'
export default ProjectOrderDetails
